import React from "react";

function ChevronUpDoubleIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M11.64 5.068c-.155.053-.547.427-2.793 2.667-1.479 1.474-2.659 2.683-2.72 2.785-.091.152-.107.226-.107.48 0 .257.016.327.113.492.13.222.369.409.603.473.203.054.531.024.709-.066.074-.037 1.13-1.06 2.345-2.273L12 7.421l2.21 2.205c1.215 1.213 2.273 2.239 2.35 2.279.099.052.228.074.44.074.258.001.327-.015.492-.112.476-.28.646-.899.374-1.359-.055-.092-1.276-1.34-2.713-2.773-2.37-2.363-2.631-2.611-2.81-2.67a1.053 1.053 0 0 0-.703.003m0 7c-.155.053-.547.427-2.793 2.667-1.479 1.474-2.659 2.683-2.72 2.785-.091.152-.107.226-.107.48 0 .257.016.327.113.492.13.222.369.409.603.473.203.054.531.024.709-.066.074-.037 1.13-1.06 2.345-2.273L12 14.421l2.21 2.205c1.215 1.213 2.273 2.239 2.35 2.279.099.052.228.074.44.074.258.001.327-.015.492-.112.476-.28.646-.899.374-1.359-.055-.092-1.276-1.34-2.713-2.773-2.37-2.363-2.631-2.611-2.81-2.67a1.053 1.053 0 0 0-.703.003"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default ChevronUpDoubleIcon;
